// Libraries
import Axios from 'config/service.config'
import envConfig from 'config/env_config'

export const getPrice = async ({ partnerId, breedId, services }) => {
  const { data } = await Axios({
    baseURL: envConfig.partner,
    url: `/prices/list/${partnerId}/${breedId}`,
    withCredentials: true,
    params: {
      services
    }
  })
  return data
}
